import { createFileRoute } from '@tanstack/react-router';
import { mkpStaticData } from '.';

export const Route = createFileRoute('/_private-routes/marketplace/add')({
  staticData: mkpStaticData
});
